export default __webpack_public_path__ + "static/media/expressJS.e3dcc02c.svg";